import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

// Native port of the legacy chooseJobBoardCredentialTypeModal
// (src/app/public/app/partials/missioncontrol/company/chooseJobBoardCredentialTypeModal) -
// opened from company-page.component.js's showCredentialTypeConfirmModal
// (component: 'chooseJobBoardCredentialTypeModal') before adding a job board
// credential, to pick password vs. key/username reuse.
@Component({
  selector: 'app-company-page-choose-job-board-credential-type-modal',
  templateUrl: './company-page-choose-job-board-credential-type-modal.component.html'
})
export class CompanyPageChooseJobBoardCredentialTypeModalComponent implements OnInit {

  public onClose: Subject<any>;

  modalData: any = {};

  addJobBoardByPasswordFlag: boolean;
  callbackObject: any = { callbackType: 'cancel', entity: {} };

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.addJobBoardByPasswordFlag = this.modalData.addJobBoardByPasswordFlag;
  }

  onTypeSelected() {
    this.callbackObject = { callbackType: 'typeChange', entity: { addJobBoardByPasswordFlag: this.addJobBoardByPasswordFlag } };
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }

  closeModal() {
    this.callbackObject = { callbackType: 'cancel', entity: {} };
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }
}
